import Header from '@/components/layout/Header';
import Footer from '@/components/layout/Footer';
import { Card } from '@/components/ui/card';

const PrivacyPolicy = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-teal-50 via-slate-50 to-white flex flex-col">
      <Header />

      <main className="flex-1">
        {/* Hero Section */}
        <div className="bg-gradient-to-r from-teal-600 to-teal-700 text-white py-16">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <h1 className="text-4xl md:text-5xl font-bold mb-4" style={{ fontFamily: 'Outfit' }}>
              Privacy Policy
            </h1>
            <p className="text-xl text-teal-100 max-w-3xl">
              Your privacy is important to us. Learn how we collect, use, and protect your information.
            </p>
          </div>
        </div>

        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
          <Card className="p-8 border-slate-200">
            <div className="prose prose-slate max-w-none">
              
              <h2 className="text-2xl font-bold text-slate-900 mb-4">1. Introduction</h2>
              <p className="text-slate-600 mb-4">
                Vallalar Velai Vaipu Sevai Iyakkam (VVVSI) values the trust our Employers and Job Seekers place in us when they give us access to their personal data. This Privacy Policy describes how we work to maintain that trust and protect that information.
              </p>
              <p className="text-slate-600 mb-6">
                This Privacy Policy details our collection, use and disclosure of personal and non-personal data you give to VVVSI when you access or use VVVSI's online websites and services.
              </p>

              <h3 className="text-xl font-semibold text-slate-900 mb-3">1.1 The VVVSI Entities Responsible for Your Information</h3>
              <p className="text-slate-600 mb-4">
                With respect to Job Seekers and Employers, for the purposes of this Privacy Policy, "VVVSI" or "we" refers to Vallalar Velai Vaipu Sevai Iyakkam if you are located in India. VVVSI is the controller for the Personal Data we process, unless otherwise stated in these terms.
              </p>

              <h3 className="text-xl font-semibold text-slate-900 mb-3">1.2 Personal Data and Non-Personal Data</h3>
              <p className="text-slate-600 mb-4">
                <strong>Personal Data</strong> refers to any information that relates to an identified or identifiable individual. <strong>Non-Personal Data</strong> refers to any information that does not identify you as a specific individual. VVVSI will adhere to applicable statutory definitions in determining what is Personal Data for purposes of this Privacy Policy.
              </p>

              <h3 className="text-xl font-semibold text-slate-900 mb-3">1.3 Scope of Privacy Policy</h3>
              <p className="text-slate-600 mb-4">
                This Privacy Policy covers only data that we collect through the Site, and not any other data collection or processing, including data collection practices of any affiliate or third party.
              </p>

              <h3 className="text-xl font-semibold text-slate-900 mb-3">1.4 Changes to the Privacy Policy</h3>
              <p className="text-slate-600 mb-6">
                VVVSI may amend this Privacy Policy at any time. Changes will become effective on the "Last Updated" date indicated. By using the Site following such changes, you accept the amended Privacy Policy.
              </p>

              <h2 className="text-2xl font-bold text-slate-900 mb-4">2. Information Collected</h2>
              <p className="text-slate-600 mb-4">
                You provide different types of information in order for VVVSI to provide our services, products and features to you. VVVSI associates this information with your VVVSI profile.
              </p>
              
              <h3 className="text-xl font-semibold text-slate-900 mb-3">2.1 Information You Provide to VVVSI</h3>
              <p className="text-slate-600 mb-6">
                We collect data when you create an VVVSI account, request information, subscribe for a service, participate in a survey, post a rating or review, post a resume, or complete assessments. This may include first and last name, email address, telephone number, street address, gender, occupation, interests, messages you send to users, and any other data included in a submitted profile or resume.
              </p>

              <h2 className="text-2xl font-bold text-slate-900 mb-4">3. Limitation of Use or Disclosure of Personal Data</h2>
              
              <h3 className="text-xl font-semibold text-slate-900 mb-3">3.1 Closing a Job Seeker Account</h3>
              <p className="text-slate-600 mb-4">
                When a Job Seeker closes an account, they will no longer have access to any data under that account name, including search history, job preferences, saved jobs, applied jobs, job alerts, resume, and any other associated data. VVVSI reserves the right to keep materials as necessary to preserve its rights or comply with legal obligations.
              </p>

              <h3 className="text-xl font-semibold text-slate-900 mb-3">3.2 Closing an Employer Account</h3>
              <p className="text-slate-600 mb-4">
                Employers may close an account at any time by contacting VVVSI Customer Support. VVVSI must preserve business records pertaining to that account to comply with legal obligations.
              </p>

              <h3 className="text-xl font-semibold text-slate-900 mb-3">3.3 Deleting Job Applications</h3>
              <p className="text-slate-600 mb-4">
                If a Job Seeker wants to delete a job application, they are advised to contact the prospective Employer directly. For applications submitted through VVVSI to an Employer, the application materials may be controlled by that Employer.
              </p>

              <h3 className="text-xl font-semibold text-slate-900 mb-3">3.4 Minimum Age</h3>
              <p className="text-slate-600 mb-4">
                The Site is not for use by anyone under the age of 18. If you are under 18, you must use VVVSI under the supervision of your parent, legal guardian or responsible adult. VVVSI adopts measures to ensure we do not accept individuals who do not meet the minimum age requirements.
              </p>

              <div className="mt-8 p-4 bg-teal-50 rounded-lg">
                <p className="text-sm text-slate-600">
                  <strong>Contact Us:</strong> If you have any questions about this Privacy Policy, please contact us at info@vvvsi.com or call +91 82705 27992.
                </p>
              </div>
            </div>
          </Card>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default PrivacyPolicy;
